import { SnackbarProvider } from "notistack";
import { withStyles } from "@material-ui/styles";

const SnackbarProviderStyled = withStyles({
  variantInfo: {
    backgroundColor: "#267C9C",
  },
})(SnackbarProvider);

export { SnackbarProviderStyled };
